export default [
  {
    path: '/master',
    name: 'list-master',
    component: () => import('@/views/master/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.master',
      resource: 'master',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listMaster',
          active: true,
        },
      ],
    },
  },
  {
    path: '/master/create',
    name: 'create-master',
    component: () => import('@/views/master/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.master',
      navActiveLink: 'list-master',
      resource: 'master',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.listMaster',
          to: { name: 'list-master' }
        },
        {
          text: 'breadcrumb.createMaster',
          active: true,
        },
      ],
    },
  },
  {
    path: '/master/:id/update',
    name: 'update-master',
    component: () => import('@/views/master/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.master',
      navActiveLink: 'list-master',
      navActiveTab: 'update-master',
      resource: 'master',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listMaster',
          to: { name: 'list-master' }
        },
        {
          text: 'breadcrumb.updateMaster',
          active: true,
        },
      ],
    },
  },
  {
    path: '/master/:id',
    name: 'view-master',
    component: () => import('@/views/master/View.vue'),
    meta: {
      pageTitle: 'breadcrumb.master',
      navActiveLink: 'list-master',
      resource: 'master',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listMaster',
          to: { name: 'list-master' }
        },
        {
          text: 'breadcrumb.viewMaster',
          active: true,
        },
      ],
    },
  },
  // Block Number
  {
    path: '/master/:id/block-number',
    name: 'list-master-block-number',
    component: () => import('@/views/master/blockNumber/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.blockNumber',
      navActiveLink: 'list-master',
      navActiveTab: 'master-block-number',
      resource: 'master',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listMaster',
          to: { name: 'list-master' }
        },
        {
          text: 'breadcrumb.listBlockNumber',
          active: true,
        },
      ],
    },
  },
  {
    path: '/master/:id/block-number/create',
    name: 'create-master-block-number',
    component: () => import('@/views/master/blockNumber/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.blockNumber',
      navActiveLink: 'list-master',
      navActiveTab: 'master-block-number',
      resource: 'master',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listMaster',
          to: { name: 'list-master' }
        },
        {
          text: 'breadcrumb.listBlockNumber',
          to: { name: 'list-master-block-number' }
        },
        {
          text: 'breadcrumb.createBlockNumber',
          active: true,
        },
      ],
    },
  },
  {
    path: '/master/:id/block-number/:blockId/update',
    name: 'update-master-block-number',
    component: () => import('@/views/master/blockNumber/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.blockNumber',
      navActiveLink: 'list-master',
      navActiveTab: 'master-block-number',
      resource: 'master',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listMaster',
          to: { name: 'list-master' }
        },
        {
          text: 'breadcrumb.listBlockNumber',
          to: { name: 'list-master-block-number' }
        },
        {
          text: 'breadcrumb.updateBlockNumber',
          active: true,
        },
      ],
    },
  },
  // Allow Number
  {
    path: '/master/:id/allow-number',
    name: 'list-master-allow-number',
    component: () => import('@/views/master/allowNumber/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.allowNumber',
      navActiveLink: 'list-master',
      navActiveTab: 'master-allow-number',
      resource: 'master',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listMaster',
          to: { name: 'list-master' }
        },
        {
          text: 'breadcrumb.listAllowNumber',
          active: true,
        },
      ],
    },
  },
  {
    path: '/master/:id/allow-number/create',
    name: 'create-master-allow-number',
    component: () => import('@/views/master/allowNumber/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.allowNumber',
      navActiveLink: 'list-master',
      navActiveTab: 'master-allow-number',
      resource: 'master',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listMaster',
          to: { name: 'list-master' }
        },
        {
          text: 'breadcrumb.listAllowNumber',
          to: { name: 'list-master-allow-number' }
        },
        {
          text: 'breadcrumb.createAllowNumber',
          active: true,
        },
      ],
    },
  },
  {
    path: '/master/:id/allow-number/:allowId/update',
    name: 'update-master-allow-number',
    component: () => import('@/views/master/allowNumber/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.allowNumber',
      navActiveLink: 'list-master',
      navActiveTab: 'master-allow-number',
      resource: 'master',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listMaster',
          to: { name: 'list-master' }
        },
        {
          text: 'breadcrumb.listAllowNumber',
          to: { name: 'list-master-allow-number' }
        },
        {
          text: 'breadcrumb.updateAllowNumber',
          active: true,
        },
      ],
    },
  },
  // Sell out
  {
    path: '/master/:id/sell-out',
    name: 'list-master-sell-out',
    component: () => import('@/views/master/sellOut/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.sellOut',
      navActiveLink: 'list-master',
      navActiveTab: 'master-sell-out',
      resource: 'master',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listSellOut',
          active: true,
        },
      ],
    },
  },
  {
    path: '/master/:id/sell-out/create',
    name: 'create-master-sell-out',
    component: () => import('@/views/master/sellOut/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.sellOut',
      navActiveLink: 'list-master',
      navActiveTab: 'master-sell-out',
      resource: 'master',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listSellOut',
          to: { name: 'list-master-sell-out' }
        },
        {
          text: 'breadcrumb.createSellOut',
          active: true,
        },
      ],
    },
  },
  {
    path: '/master/:id/sell-out/:sellOutId/update',
    name: 'update-master-sell-out',
    component: () => import('@/views/master/sellOut/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.sellOut',
      navActiveLink: 'list-master',
      navActiveTab: 'master-sell-out',
      resource: 'master',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listSellOut',
          to: { name: 'list-master-sell-out' }
        },
        {
          text: 'breadcrumb.updateSellOut',
          active: true,
        },
      ],
    },
  },
  // Setting
  {
    path: '/master/:id/bet-setting',
    name: 'list-master-bet-setting',
    component: () => import('@/views/master/betSetting/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.betSetting',
      navActiveLink: 'list-master',
      navActiveTab: 'master-bet-setting',
      resource: 'master',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listBetSetting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/master/:id/bet-setting/create',
    name: 'create-master-bet-setting',
    component: () => import('@/views/master/betSetting/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.betSetting',
      navActiveLink: 'list-master',
      navActiveTab: 'master-bet-setting',
      resource: 'master',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listBetSetting',
          to: { name: 'list-master-bet-setting' }
        },
        {
          text: 'breadcrumb.createBetSetting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/master/:id/bet-setting/:betSettingId/update',
    name: 'update-master-bet-setting',
    component: () => import('@/views/master/betSetting/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.betSetting',
      navActiveLink: 'list-master',
      navActiveTab: 'master-bet-setting',
      resource: 'master',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listBetSetting',
          to: { name: 'list-master-bet-setting' }
        },
        {
          text: 'breadcrumb.updateBetSetting',
          active: true,
        },
      ],
    },
  },
]
